module.exports = __webpack_public_path__ + "img/mastercard.7b87f5a.png";